export class DimonaCodeNotis {
  id: number;
  active: boolean;
  code: string;
  labelFR: string;
  labelEN: string;
  labelNL: string;
}
